import { useId } from 'react';

const useUniqueTabIds = () => {
    const uniqueId = useId();

    const getTabId = (key: string) => `tabs-${uniqueId}-tab-${key}`;

    const getPanelId = (key: string) => `tabs-${uniqueId}-tabpanel-${key}`;

    return { getTabId, getPanelId };
};

export default useUniqueTabIds;
